import React from "react";
import styled from "styled-components";
import Trianglify from "trianglify";
import Dimensions from "react-dimensions";
import { compose, lifecycle } from "recompose";

const colors = {
  blue: [
    "#eeeeee",
    "#ece7f2",
    "#d0d1e6",
    "#a6bddb",
    "#74a9cf",
    "#3690c0",
    "#0570b0",
    "#045a8d",
    "#023858"
  ],
  blueGreen: [
    "#f7fcf0",
    "#e0f3db",
    "#ccebc5",
    "#a8ddb5",
    "#7bccc4",
    "#4eb3d3",
    "#2b8cbe",
    "#0868ac",
    "#084081"
  ],
  grey: ["#ccc", "#ddd", "#fff", "#ccc", "#888"]
};

const trianglifyConfig = {
  cell_size: 60,
  x_colors: ["#eee", "#fff", "#fff", "#fff", "#eee"],
  y_colors: colors.grey
};

const update = () => {
  let parent = document.getElementById("parent");
  let child = document.getElementById("triangles");
  const width = parent.clientWidth,
    height = parent.clientHeight;
  let pattern = Trianglify({
    height,
    width,
    cell_size: 60,
    x_colors: ["#eee", "#fff", "#fff", "#fff", "#eee"],
    y_colors: colors.grey
  });

  let canvas = pattern.canvas();
  canvas.id = "triangles";
  parent.replaceChild(canvas, child);
};

class Triangles extends React.Component {
  timer;
  onResize = () => {
    update();
  };
  resizeHandler = () => {
    this.timer && clearTimeout(this.timer);
    this.timer = setTimeout(this.onResize, 100);
  };

  componentDidMount() {
    update();
    window.addEventListener("resize", this.resizeHandler);
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeHandler);
  }

  render() {
    return (
      <div
        id="parent"
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }}
      >
        <div id="triangles" style={{ height: "100%", width: "100%" }} />
      </div>
    );
  }
}

const AbsoluteFill = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.8;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 97vh;
`;

const Background = compose(
  Dimensions(),
  lifecycle({
    shouldComponentUpdate() {
      return false;
    }
  })
)(Triangles);

export default ({ children }) => {
  return (
    <Container>
      <AbsoluteFill>
        <Background />
      </AbsoluteFill>
      {children}
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/components/blocks/TriangleBackground.js